<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
export default {
  methods: {
    onLoad() {
      if (!this.$route.params.name) {
        window.location.href = "https://comenta.ai";
      }
    },
  },
  mounted() {
    this.onLoad();
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;0,600;0,700;0,800;0,900;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");

* {
  font-family: "Poppins", sans-serif !important;
}

h1 {
  font-size: 28px;
  font-weight: normal;
  text-transform: none;
}

h2 {
  font-size: 20px;
  font-weight: normal;
  text-transform: none;
}

h3 {
  font-size: 16px;
  font-weight: normal;
  text-transform: none;
}

h4 {
  font-size: 14px;
  font-weight: normal;
  text-transform: none;
}
.appcomenta {
  max-width: 600px;
  margin: 0 auto;
}

.img-logo {
  max-width: 240px;
}

.full-width {
  min-width: 100%;
  padding: 0px;
}

.finalcode {
  border-radius: 15px;
  font-size: 24px;
  font-weight: bolder;
}

@media (max-width: 600px) {
  .appcomenta {
    max-width: 100%;
    margin: 0 auto;
  }

  .img-logo {
    max-width: 90%;
  }
}
</style>
